import React, { Component } from 'react';
import Helmet from 'react-helmet';

import './App.css';
import AppRouter from './AppRouter'
import Header from './Header'

class App extends Component {
  
  render() {
    return (
        <div className="App">
          <Helmet>
            <title>chordial.us - piano chord charts</title>
            <meta name="description" content="chordial.us - piano chord charts"/>
          </Helmet>
          <Header/>
          <AppRouter/>
        </div>
    )
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js